import type { FC } from 'react';

import Checkbox from '../../../checkbox/checkbox';
import {
  type FieldWrapperProps,
  FormContextConsumer,
} from '../../form_context/form_context';
import formField from '../../form_field/form_field';

const Field = formField(Checkbox, {
  defaultValue: false,
});

export type CheckboxFieldWrapperProps = FieldWrapperProps<typeof Field>;

const CheckboxFieldWrapper: FC<CheckboxFieldWrapperProps> = (props) => (
  <FormContextConsumer>
    {(context) => <Field {...props} {...context} />}
  </FormContextConsumer>
);

export default CheckboxFieldWrapper;
